module.exports = __webpack_public_path__ + "assets/TriangleMidSegment.fe4ec77f455a6bacc415865b9f345be4.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/TriangleMidSegment.gmt
// module id = 1030
// module chunks = 0